export function toKebabFromPascal (str: string) {
  return str
    .split(/(?=[A-Z])/)
    .map(el => el.toLowerCase())
    .join('-');
}
